// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css - 全局样式和CSS变量 */

/* ===== CSS变量 ===== */
:root {
  --primary: #00e5ff;
  --secondary: #7e57ff;
  --bg-dark: #050810;
  --card-bg: rgba(16, 22, 42, 0.7);
  --text-main: #ffffff;
  --text-dim: #a0aec0;
}

/* ===== 基础重置 ===== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Exo 2', sans-serif;
  background-color: var(--bg-dark);
  color: var(--text-main);
  overflow-x: hidden;
}

/* ===== 全局背景效果 ===== */
.bg-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -3;
  background:
    radial-gradient(circle at 20% 30%, #0d1428 0%, #050810 60%),
    radial-gradient(circle at 80% 70%, rgba(30, 25, 60, 0.3) 0%, transparent 40%);
}

.stars {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -2;
  background: url('https://www.transparenttextures.com/patterns/stardust.png');
  opacity: 0.4;
  mix-blend-mode: screen;
}

/* 简化的科技感光效 */
.tech-glow {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 800px;
  height: 800px;
  background: radial-gradient(
    circle,
    rgba(0, 229, 255, 0.08) 0%,
    rgba(126, 87, 255, 0.05) 30%,
    transparent 70%
  );
  z-index: -2;
  filter: blur(60px);
  animation: gentlePulse 8s ease-in-out infinite;
}

@keyframes gentlePulse {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 0.8; }
}

/* ===== 全局动画 ===== */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ===== App根容器 ===== */
.App {
  min-height: 100vh;
  position: relative;
}

/* ===== 滚动条样式 ===== */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--bg-dark);
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 229, 255, 0.3);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 229, 255, 0.5);
}

/* ===== 选择文本样式 ===== */
::selection {
  background: rgba(0, 229, 255, 0.3);
  color: #fff;
}

::-moz-selection {
  background: rgba(0, 229, 255, 0.3);
  color: #fff;
}

/* ===== 页面视图样式 ===== */
.main-content {
  padding-top: 60px; /* Header 高度 */
  min-height: 100vh;
}

.main-content.page-view {
  padding-top: 80px;
  padding-bottom: 40px;
}

.page-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  min-height: 60vh;
}

.page-content {
  text-align: center;
}

/* ===== 首页"我的作品"区域 ===== */
.home-my-works-section {
  width: 100%;
  padding: 0 5%;
  margin: 40px 0;
  position: relative;
  z-index: 1;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,sBAAsB;AACtB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX;;iFAE+E;AACjF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,4EAA4E;EAC5E,YAAY;EACZ,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb;;;;;GAKC;EACD,WAAW;EACX,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,YAAY,EAAE;AACtB;;AAEA,qBAAqB;AACrB;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,uBAAuB;AACvB;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,iBAAiB,EAAE,cAAc;EACjC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":["/* App.css - 全局样式和CSS变量 */\n\n/* ===== CSS变量 ===== */\n:root {\n  --primary: #00e5ff;\n  --secondary: #7e57ff;\n  --bg-dark: #050810;\n  --card-bg: rgba(16, 22, 42, 0.7);\n  --text-main: #ffffff;\n  --text-dim: #a0aec0;\n}\n\n/* ===== 基础重置 ===== */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Exo 2', sans-serif;\n  background-color: var(--bg-dark);\n  color: var(--text-main);\n  overflow-x: hidden;\n}\n\n/* ===== 全局背景效果 ===== */\n.bg-layer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -3;\n  background:\n    radial-gradient(circle at 20% 30%, #0d1428 0%, #050810 60%),\n    radial-gradient(circle at 80% 70%, rgba(30, 25, 60, 0.3) 0%, transparent 40%);\n}\n\n.stars {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -2;\n  background: url('https://www.transparenttextures.com/patterns/stardust.png');\n  opacity: 0.4;\n  mix-blend-mode: screen;\n}\n\n/* 简化的科技感光效 */\n.tech-glow {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 800px;\n  height: 800px;\n  background: radial-gradient(\n    circle,\n    rgba(0, 229, 255, 0.08) 0%,\n    rgba(126, 87, 255, 0.05) 30%,\n    transparent 70%\n  );\n  z-index: -2;\n  filter: blur(60px);\n  animation: gentlePulse 8s ease-in-out infinite;\n}\n\n@keyframes gentlePulse {\n  0%, 100% { opacity: 0.5; }\n  50% { opacity: 0.8; }\n}\n\n/* ===== 全局动画 ===== */\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* ===== App根容器 ===== */\n.App {\n  min-height: 100vh;\n  position: relative;\n}\n\n/* ===== 滚动条样式 ===== */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--bg-dark);\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(0, 229, 255, 0.3);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 229, 255, 0.5);\n}\n\n/* ===== 选择文本样式 ===== */\n::selection {\n  background: rgba(0, 229, 255, 0.3);\n  color: #fff;\n}\n\n::-moz-selection {\n  background: rgba(0, 229, 255, 0.3);\n  color: #fff;\n}\n\n/* ===== 页面视图样式 ===== */\n.main-content {\n  padding-top: 60px; /* Header 高度 */\n  min-height: 100vh;\n}\n\n.main-content.page-view {\n  padding-top: 80px;\n  padding-bottom: 40px;\n}\n\n.page-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 20px;\n  min-height: 60vh;\n}\n\n.page-content {\n  text-align: center;\n}\n\n/* ===== 首页\"我的作品\"区域 ===== */\n.home-my-works-section {\n  width: 100%;\n  padding: 0 5%;\n  margin: 40px 0;\n  position: relative;\n  z-index: 1;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
